<template>
  <div class="error">
    <h2>Oops</h2>
    <p>有什麼錯誤發生了，請稍後再重試，如果持續發生，請聯絡網站管理員，謝謝</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.error {
  max-width: 250px;
  margin: auto;
  text-align: center;
}
</style>
